import "./App.css";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./router/Router";
import { ProfileProvider } from "./context/ProfileContext";
import { AuthProvider } from "./context/AuthContext";
import LogoutListener from "./LogoutListener";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <LogoutListener />
          <Router />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
